export function isAdminPath(path = '') {
  return /^\/(platform\/o|admin)\/[^/]+(?:\/|$)/.test(path);
}

export function adminParent(path = '') {
  const match = path.match(/^\/(?:platform\/o|admin)\/([^/]+)(?:\/(.*))?$/);
  if (!match) return null;
  const base = `/platform/o/${match[1]}`;
  const section = match[2] || '';
  if (/^campaigns\//.test(section)) return {href: `${base}/dashboard#campaigns`, label: 'Campaign Center'};
  if (/^team-workspaces\//.test(section) || /^teams\//.test(section)) return {href: `${base}/teams`, label: 'Internal Teams'};
  if (/^cuisine\//.test(section)) return {href: `${base}/cuisine`, label: 'Cuisine Studio'};
  return {href: `${base}/dashboard`, label: 'Dashboard'};
}
